import "./Inscription.css";
import { MDBBtn, MDBCol, MDBContainer, MDBInput, MDBRow, } from "mdb-react-ui-kit";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from 'react-toastify';
import { getProfile, http } from "../../components/services/httpService";

export default function InscriptionCandidat() {

  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const history = useHistory();
  const [loggedInManagerId, setLoggedInManagerId] = useState(null);
  const [role] = useState("CANDIDAT");

  useEffect(() => {
    async function fetchLoggedInManager() {
      try {
        const response = await getProfile();
        if (response.ok) {
          const data = await response.json();
          if (data && data.id) {
            setLoggedInManagerId(data.id);
          }
        }
      } catch (error) {
        console.error("Error al obtener el perfil del manager", error);
      }
    }

    fetchLoggedInManager();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      firstname,
      lastname,
      email,
      role,
      invitingManagerId: loggedInManagerId
    };

    http("api/v1/auth/register", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    }).then(r => {
      if (!r.ok) {
        throw new Error("Erreur de connexion");
      }

      toast.success("Inscription réussie ! Veuillez vérifier votre e-mail pour activer votre compte.");

      history.push("/candidats");
    }).catch(error => {
      console.error(error);
      setError("Cet email est déjà utilisé, veuillez en choisir un autre.");
    });
  };

  return (
    <MDBContainer fluid className="fond-accueil inscription">
      <MDBRow className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "90VH" }}>
        <MDBCol md="6" className="form-card">
          <form onSubmit={handleSubmit}>
            <p className="h5 text-center mb-4">Inscrire un candidat</p>
            <div className="row">
              <div className="col-6 mb-2">
                <MDBInput
                  label="Prénom"
                  name="prenom"
                  type="text"
                  value={firstname}
                  onChange={(e) => setFirstname(e.target.value)}
                  required
                  contrast
                />
              </div>
              <div className="col-6">
                <MDBInput
                  label="Nom"
                  name="nom"
                  icon="user"
                  type="text"
                  value={lastname}
                  onChange={(e) => setLastname(e.target.value)}
                  required
                  contrast
                />
              </div>
            </div>
            <div>
              <MDBInput
                label="Email"
                name="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}\??$"
                required
                className="mb-4"
                contrast
              />
            </div>
            
            <div className="d-flex align-items-center justify-content-center mb-4 gap-3">
              <MDBBtn type="submit" className="BtnCard mb-4 mt-4">Envoyer</MDBBtn>
            </div>
            {error && <div className="alert alert-danger">{error}</div>}
          </form>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  );
};
